// https://raw.githack.com/MrRio/jsPDF/master/docs/jsPDF.html#setFontSize
// https://www.npmjs.com/package/jspdf-html2canvas
// https://github.com/simonbengtsson/jsPDF-AutoTable?tab=readme-ov-file
// import html2PDF from "jspdf-html2canvas";

import { jsPDF } from 'jspdf';
import { autoTable } from 'jspdf-autotable'

let tables = document.getElementById('lmt-ptMonths'),
    // printTable = document.querySelector('.lmt__table__wrapper'),
    printButton = document.createElement('button'),
    logo = '/wp-content/uploads/2025/03/cropped-favicon.png',
    webSiteTitle = LMTVars.lmt_site_name,
    webSiteSubTitle = LMTVars.lmt_site_description,
    pageTitle = 'Orario mensile';

printButton.id = 'lmt-print-btn';
printButton.innerHTML = '<svg class="brxe-icon" id="brxe-xzpfax" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 7h-1V2H6v5H5c-1.654 0-3 1.346-3 3v7c0 1.103.897 2 2 2h2v3h12v-3h2c1.103 0 2-.897 2-2v-7c0-1.654-1.346-3-3-3zM8 4h8v3H8V4zm8 16H8v-4h8v4zm4-3h-2v-3H6v3H4v-7c0-.551.449-1 1-1h14c.552 0 1 .449 1 1v7z"></path><path d="M14 10h4v2h-4z"></path></svg>';


if (tables && printButton) {
    tables.prepend(printButton);
    printButton.addEventListener('click', printPrayerTimesPdf)
}

function printPrayerTimesPdf() {
    const pdf = new jsPDF();
    autoTable(pdf, {
        html: '.lmt__pt__table_month',
        theme: 'grid',
        includeHiddenHtml: true,
        willDrawPage: function (data) {
            // Header
            pdf.setTextColor('#2e7474');
            if (logo) {
                pdf.addImage(logo, 'PNG', data.settings.margin.left, 5, 16, 16);
            }
            pdf.addFont('/wp-content/uploads/2025/03/Philosopher.ttf', 'Philosopher', 'normal')
            pdf.setFont('Philosopher') // set font
            pdf.setFontSize(16);
            pdf.text(webSiteTitle, data.settings.margin.left + 18, 12);
            pdf.addFont('/wp-content/uploads/2025/03/Montserrat.ttf', 'Montserrat', 'normal');
            pdf.setFont('Montserrat');
            pdf.setFontSize(12);
            pdf.text(webSiteSubTitle, data.settings.margin.left + 18, 18);
            pdf.setTextColor('#044040');
            pdf.setFontSize(18);
            pdf.text(pageTitle, data.settings.margin.left + 75, 30);
        },
        didDrawPage: function (data) {
            // Footer
            let jumah_time = `*Venerdì – ${LMTVars.jumah_title}: ${LMTVars.jumah_time}`;
            let copyrights = `© ${LMTVars.lmt_site_name} | ${LMTVars.lmt_post_address} | ${LMTVars.lmt_home_url}`;
            // jsPDF 1.4+ uses getHeight, <1.4 uses .height
            let pageSize = pdf.internal.pageSize;
            let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            pdf.setFontSize(10);
            pdf.setTextColor('#000000');
            pdf.text(jumah_time, data.settings.margin.left, pageHeight - 13);
            pdf.setTextColor('#bcc5ce');
            pdf.text(copyrights, data.settings.margin.left, pageHeight - 5);
        },
        headStyles: {
            fillColor: [46, 116, 116],
        },
        tableLineWidth: 0.5,
        tableLineColor: [46, 116, 116],
        styles: { valign: 'middle', halign: 'center' },
        startY: 35,
        margin: 10,
    });
    pdf.save(`${webSiteTitle}_Orario_mensile.pdf`);
}

// let printBtn = document.getElementById('lmt-print-btn'),
//     printTable = document.getElementById('lmt-ptMonths'),
//     logo = '/wp-content/uploads/2024/02/favicon.png',
//     webSiteTitle = LMTVars.lmt_site_name,
//     webSiteSubTitle = LMTVars.lmt_site_description,
//     pageTitle = 'Orario mensile';
//
// if (printBtn) {
//     printBtn.addEventListener('click', printPdf);
// }
//
// async function printPdf() {
//
//     const pdf = await html2PDF(printTable, {
//         jsPDF: {
//             format: 'a4',
//         },
//         html2canvas: {
//             scrollX: 0,
//             scrollY: -window.scrollY,
//             imageTimeout: 500,
//         },
//         imageType: 'image/jpeg',
//         margin: {top: 90, right: 10, bottom: 20, left: 10},
//         watermark: {
//             src: logo,
//             handler({pdf, imgNode, pageNumber, totalPageNumber}) {
//                 const props = pdf.getImageProperties(imgNode)
//                 pdf.addImage(imgNode, 'PNG', 10, 5, 40, 40)
//                 pdf.addFont('/wp-content/uploads/2024/02/Philosopher.ttf', 'Philosopher', 'normal')
//                 pdf.setFont('Philosopher') // set font
//                 pdf.setFontSize(18)
//                 pdf.setTextColor('#2e7474')
//                 pdf.text(webSiteTitle, 55, 25)
//                 pdf.addFont('/wp-content/uploads/2024/02/Montserrat.ttf', 'Montserrat', 'normal')
//                 pdf.setFont('Montserrat')
//                 pdf.setFontSize(10)
//                 pdf.text(webSiteSubTitle, 55, 40)
//                 pdf.setFontSize(18)
//                 pdf.setTextColor('#044040')
//                 pdf.text(pageTitle, 300, 75, 'center')
//                 pdf.setFontSize(10)
//                 pdf.setTextColor('#bcc5ce')
//                 pdf.text(
//                     10,
//                     pdf.internal.pageSize.height - 8,
//                     `© ${LMTVars.lmt_site_name} | ${LMTVars.lmt_post_address} | ${LMTVars.lmt_home_url}`
//                 )
//             }
//         },
//         output: `${LMTVars.lmt_site_name}_Orario_mensile.pdf`,
//         success: function (pdf) {
//             pdf.save(this.output);
//         },
//     });
// }

